import '@Application/Bootstrap';

import autoload from '@123/druid/dist/Framework/Decorators/Autoload';
import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject} from '@123/druid/dist/Framework/Decorators/Inject';
import View from '@123/druid/dist/Framework/View/View';
import AidenAdvisorView from '@Component/Aiden/AidenAdvisorView';
import QuickFilter from '@Module/Group/Component/QuickFilter/QuickFilter';
import AlternativeButtonView from '../../../Component/Recommendation/Button/AlternativeButtonView';
import EventHub from '@Service/LegacyBridge/EventHub/EventHub';

@autoload
@component
export default class GroupListModuleView extends View {
    constructor(@inject(QuickFilter) quickFilter: QuickFilter) {
        super();
        this.register(quickFilter);
        this.addEventHubListeners();
    }

    protected mounted(): void {
        this.getViews(AidenAdvisorView);
        this.getViews(AlternativeButtonView);
    }

    private addEventHubListeners(): void {
        EventHub.instance.on('ResultList.Updated', () => {
            this.getViews(AlternativeButtonView);
        });
    }
}
